import React, { useState } from 'react';
import './SingleCard.css';

const SingleCard = ({ card, handleChoice, flipped, disabled }) => {
  const [clicked, setClicked] = useState(false);

  // /if disabled false & if clicked false
  const handleClick = () => {
    setClicked(true);
    if (!disabled && !clicked) {
      handleChoice(card);
    }
    setTimeout(() => setClicked(false), 500);
  };

  return (
    <div className="card">
      <div className={flipped ? 'flipped' : ''}>
        <img className="front" src={card.src} alt="card front" />
        <img
          className="back"
          src="/img/cover.png"
          alt="cover"
          onClick={handleClick}
        />
      </div>
    </div>
  );
};

export default SingleCard;
